<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <br />
    <v-card class="card">
      <v-card-title class="heading justify-center"
        >Subject Wise Dashboard</v-card-title
      >
      <v-card-text>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="3">
              <!-- <label>Program Type</label> -->
              <v-autocomplete
                label="Select Program Type"
                :items="programtype_list"
                item-text="progtype_name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
                v-model="programtype"
                @change="getPrograms"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <!-- <label>Program Type</label> -->
              <v-autocomplete
                label="Select Program"
                :items="program_list"
                item-text="prog_name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
                v-model="program"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3">
              <!-- <label>Program Type</label> -->
              <v-autocomplete
                label="Select Year"
                :items="year_list"
                item-text="year_name"
                item-value="id"
                persistent-hint
                return-object
                outlined
                dense
                v-model="year"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          class="mb-2 button btn"
          :loading="button_load"
          @click="fetchdetails()"
          >Fetch</v-btn
        >
      </v-card-actions>
    </v-card>
    <br />
    <v-card class="card" v-if="table_data != ''">
      <v-card-text>
        <template>
          <v-data-table
            :headers="headers"
            :items="table_data"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Student Data</v-toolbar-title>
                <v-divider class="mx-10" inset vertical></v-divider>
                <!-- <v-spacer></v-spacer> -->
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <span style="width: 20px"></span>
                <download-excel
                  class="mar"
                  :data="table_data"
                  :fields="outer_table_headers_for_export"
                  worksheet="table_data"
                  name="Student Data Report.xls"
                >
                  <v-btn color="success" dark class="mb-2"
                    >Export<v-icon dark>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-toolbar>
            </template>
            <template v-slot:item.registered_student_count="{ item }">
              <span
                @click="getStudentList(item, 'registered')"
                style="cursor: pointer"
                ><a>#{{ item.registered_student_count }}</a></span
              >
            </template>
            <template v-slot:item.present_student_count="{ item }">
              <span
                @click="getStudentList(item, 'present')"
                style="cursor: pointer"
                ><a>#{{ item.present_student_count }}</a></span
              >
            </template>
            <template v-slot:item.absent_student_count="{ item }">
              <span
                @click="getStudentList(item, 'absent')"
                style="cursor: pointer"
                ><a>#{{ item.absent_student_count }}</a></span
              >
            </template>
          </v-data-table>
        </template>
      </v-card-text>
      <template>
        <v-row justify="center">
          <v-dialog
            v-model="student_data"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="student_data = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Student Data</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-row class="justify-center">
                <v-col cols="12">
                  <v-toolbar flat color="white">
                    <!-- <v-toolbar-title>Student Data</v-toolbar-title> -->
                    <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
                    <!-- <v-spacer></v-spacer> -->
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <download-excel
                      class="mar"
                      :data="inside_student_list"
                      :fields="inside_table_headers_for_export"
                      worksheet="inside_student_list"
                      name="Student Data Report.xls"
                    >
                      <v-btn color="success" dark class="mb-2"
                        >Export<v-icon dark>mdi-file-excel</v-icon>
                      </v-btn>
                    </download-excel>
                  </v-toolbar>
                  <v-data-table
                    :headers="inside_headers"
                    :items="inside_student_list"
                    class="elevation-1"
                    :search="search"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
export default {
  data: () => ({
    color: "",
    snackbar: false,
    snackbar_msg: "",
    programtype_list: [],
    program_list: [],
    programtype: null,
    program: null,
    year: null,
    year_list: [],
    table_data: [],
    student_data: false,
    inside_student_list: [],
    search: "",
    button_load: false,
    all_for_programtype: null,
    all_for_program: null,
    all_for_year: null,
    outer_table_headers_for_export: {
      "Sr.No.":"srno",
      "Course Code": "course_code",
      "Registered Students": "registered_student_count",
      "Present Students": "present_student_count",
      "Absent Students": "absent_student_count",
    },
    inside_table_headers_for_export: {
      "Sr.No.": "inner_srno",
      "Course Code": "course_code",
      "Seat No.": "seat_no",
      "Registration Number": "gr_no",
      "Student Name": "student_name",
      "Status": "status",
    },
    headers: [
      { text: "Sr.No.", value: "srno" },
      { text: "Course", value: "course_code" },
      {
        text: "Registered Students",
        value: "registered_student_count",
        align: "center",
      },
      {
        text: "Present Students",
        value: "present_student_count",
        align: "center",
      },
      {
        text: "Absent Students",
        value: "absent_student_count",
        align: "center",
      },
    ],
    inside_headers: [
      {
        text: "Sr.No.",
        value: "inner_srno",
      },
      {
        text: "Course Code",
        value: "course_code",
      },
      {
        text: "Seat No.",
        value: "seat_no",
      },
      {
        text: "Registration Number",
        value: "gr_no",
      },
      {
        text: "Student Name",
        value: "student_name",
      },
      {
        text: "Status",
        value: "status",
      },
    ],
  }),
  mounted() {
    axios
      .get("/COE/subjectwiseDashboard")
      .then((res) => {
        if (res.data.msg == "200") {
          this.programtype_list = res.data.programtype_list;
          this.all_for_programtype = { progtype_name: "All", id: "0" };
          this.programtype_list.push(this.all_for_programtype);

          this.year_list = res.data.year_list;
          this.all_for_year = { year_name: "All", id: "0" };
          this.year_list.push(this.all_for_year);

          this.program_list = res.data.program_list;
          this.all_for_program = { prog_name: "All", id: "0" };
          this.program_list.push(this.all_for_program);
        }
      })
      .catch((error) => {
        window.console.log(error);
      });
  },
  methods: {
    getStudentList(value, type) {
      this.student_data = true;
      for (let i = 0; i < this.table_data.length; i++) {
        if (this.table_data[i].course_code == value.course_code) {
          if (type == "registered") {
            this.inside_student_list = this.table_data[
              i
            ].registered_student_data;
          } else if (type == "present") {
            this.inside_student_list = this.table_data[i].present_student_data;
            // this.inside_student_list = this.table_data.present_student_data
          } else if (type == "absent") {
            this.inside_student_list = this.table_data[i].absent_student_data;
          }
        }
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getPrograms() {
      console.log(this.programtype.progtype_name);
      if (this.programtype.progtype_name == "All") {
        this.program_list = [];
        this.all_for_program = { prog_name: "All", id: "0" };
        this.program_list.push(this.all_for_program);
      } else {
        const data = {
          program_type_id: this.programtype.id,
        };
        console.log("data: " + data.program_type_id.id);
        axios
          .post("COE/getPrograms", data)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.program_list != "") {
                this.program_list = res.data.program_list;
                this.all_for_program = { prog_name: "All", id: "0" };
                this.program_list.push(this.all_for_program);
              } else {
                this.all_for_program = { prog_name: "All", id: "0" };
                this.program_list.push(this.all_for_program);
              }
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          });
      }
    },
    fetchdetails() {
      if (this.programtype == null) {
        this.showSnackbar("#b71c1c", "Please choose Program Type!");
      } else if (this.program == null) {
        this.showSnackbar("#b71c1c", "Please choose Program!");
      } else if (this.year == null) {
        this.showSnackbar("#b71c1c", "Please choose Year!");
      } else {
        this.button_load = true;
        const data = {
          program_type_id: this.programtype.id,
          program_id: this.program.id,
          year_id: this.year.id,
        };
        axios
          .post("COE/fetchDataforSubjectwiseDashboard", data)
          .then((res) => {
            this.button_load = false;
            if (res.data.msg == "200") {
              if (res.data.main_array == "") {
                this.showSnackbar("#b71c1c", "No Data found!");
                this.table_data = []
              } else {
                this.table_data = res.data.main_array;
                console.log(this.table_data);
              }
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong...");
            }
          })
          .catch((error) => {
            this.button_load = false;
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            this.button_load = false;
          });
      }
    },
  },
};
</script>

<style>
.card {
  border: 2px solid hsla(190, 99%, 30%, 1) !important;
}
</style>